import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function cancelStageSignoffRequest(
   signoff_requestid: number,
   common: CommonRequestOptions = {}
): Promise<void> {
   return await makeRequest('delete', 'courses/stage-sign-offs/requests/' + signoff_requestid, {
      ...common,
      body: {},
   });
}
